import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Accordion,
  NoValue,
  MultiColumnList,
} from '@folio/stripes/components';
import {
  USER_FIELDS,
} from '../../../../../../constants';
import { getLastFirstUserName } from '../../../../../../utils';

const visibleColumns = [
  USER_FIELDS.NAME,
  USER_FIELDS.EMAIL,
];

const columnMapping = {
  [USER_FIELDS.NAME]: <FormattedMessage id="ui-task-list.user.field.name" />,
  [USER_FIELDS.EMAIL]: <FormattedMessage id="ui-task-list.user.field.email" />,
};

const resultsFormatter = {
  [USER_FIELDS.NAME]: (data) => getLastFirstUserName(data),
  [USER_FIELDS.EMAIL]: (data) => (
    data.personal.email ?
      data.personal.email :
      <NoValue />
  ),
};

const AssignedUsers = ({ users }) => {
  return (
    <Accordion
      id="assignedUsers"
      label={<FormattedMessage id="ui-task-list.title.accordion.assignUsers" />}
    >
      <MultiColumnList
        columnMapping={columnMapping}
        contentData={users}
        formatter={resultsFormatter}
        id="assignedUsersList"
        visibleColumns={visibleColumns}
      />
    </Accordion>
  );
};

AssignedUsers.propTypes = {
  users: PropTypes.array.isRequired
};

export default AssignedUsers;
